import {
  GET_SEARCH_DATA,
  GET_SEARCH_GUEST_DATA,
  GET_OCCUPIED_LIST,
  GET_GLOBAL_SEARCH_ROLES
} from './../constants/actionTypes'

export const getSearchData = data => dispatch => {
  dispatch({
    type: GET_SEARCH_DATA,
    data
  })
}
export const getSearchGuestData = data => dispatch => {
  dispatch({
    type: GET_SEARCH_GUEST_DATA,
    data
  })
}
export const getOccupiedList = data => dispatch => {
  dispatch({
    type: GET_OCCUPIED_LIST,
    data
  })
}
export const getGlobalSearchRoles = data => dispatch => {
  dispatch({
    type: GET_GLOBAL_SEARCH_ROLES,
    data
  })
}
